// src/components/button/BtnPoolInfo.tsx

import { InfoTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'

type BtnPoolInfoProps = {
  onClick?: () => void
}

export const BtnPoolInfo = ({ onClick }: BtnPoolInfoProps) => (
  <Tooltip arrow placement={'top'} title={'Pool Informationen'}>
    <IconButton onClick={onClick} sx={{ bgcolor: '#DDD' }}>
      <InfoTwoTone />
    </IconButton>
  </Tooltip>
)
